module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAMAAABg3Am1AAAAaVBMVEUAAAD/pEoZnwv/pEn/pkoboQ0angobnwr/pEoanwv///8YGpPd3e/IyOVub7tERqioqdb7+/7Y2O0vMZ709PrExOO/wOGen9KYmM6Oj8p7fMF1dr9naLhZW7E8PaQnKZodHpUaHJSoqNYvYr1fAAAACHRSTlMA8PCuJiaurShm1BQAAACXSURBVEjH7dK5DsMgEEXRAYxN8jDgJfue///IIKXF0kxBx2nhipUals4ox6RMl+crJ6A6Mk7EkJIFipxQC+oE+5I13cJlLg4Vg+OC7HOdmMH4xl/gBdMTuI/z+QUcWMEIPHyWgMAKTkDyMXq/IIoD8ZbEh5Zea6WHy9bv9tfYCbWgTqBl8zX1sqAnq0ULWCI7sBM9WGo4fispPwGbB5vmAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/flag/hi@2x.png
// module id = rgcX
// module chunks = 0